const dev = {
  API_URL: 'http://localhost:52189'
}

const stage = {
  API_URL: 'https://api-staging.synkedup.com'
}

const prod = {
  API_URL: 'https://api.synkedup.com'
}

const config = process.env.REACT_APP_ENV === 'PROD'
  ? prod
  : (process.env.REACT_APP_ENV === 'STAGE'
    ? stage
    : dev)

export default {
  ...config
}
